import script from "./preview-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./preview-modal.vue?vue&type=script&lang=ts&setup=true"

import "./preview-modal.vue?vue&type=style&index=0&id=21563cf0&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21563cf0"]])

export default __exports__